import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import FrmSubscriptionCheck from '../../../RestAPI/FrmSubscription';
import PartnerFRMSubscriptionCheck from '../../../RestAPI/PartnerSubscription/FrmSubscription';
import language from '../../../../assets/languages/language';
import ModalComponent from '../../../Common/Modal';
import AlertMessage from '../../../config/alertMessage';
import Loader from '../../../../common/loader';
import CBTMockExamsInsructions from '../../../Common/CBTInstructions';
import moment from 'moment';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';
import { SecondsToHHMMSS } from '../../../../common/constant';

class CBTMockExams extends Component {
  constructor(props) {
    super(props);
    var messageTitle_frm = `<i class="icon-info icons font-2xl d-block "></i>`;
    this.state = {
      alert_status: false,
      pdfAlert: false,
      MessageTitle: messageTitle_frm,
      MessageContent: AlertMessage.messageContent_frm,
      mockList: [],
      token: '',
      idname: '',
      ValidToken: false,
      subscriptionstatus: '',
      showFreePremium: true,
      selectedmenu: 'frm',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      type: 'question',
      PDFContentMessage: language.LC().PDFContentMessage,
      isLoading: true,
      mockData: '',
      userStatsData: '',
      mockName: '',
      deletepopup: false,
      deleteId: '',
      questionsLength: 90,
    };
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  //it is use to redirect page
  static contextTypes = {
    router: React.PropTypes.object,
  };

  //Function to redirect page to viewquestions page
  getQuestions = () => {
    this.setState({
      showInstructionModal: false,
      isLoading: true,
    });
    var user_data = { token: this.state.token, idname: this.state.idname };
    FD.callAPI(App_data.backend_api + '/user/getProfileInfo', user_data).then(resp => {
      let data_arr = resp.profileInfo.exam_selected
        ? JSON.parse(resp.profileInfo.exam_selected)
        : null;
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({
            isLoading: false,
          });
          this.toggleAlert();
        } else {
          var dataset = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                const examPlanData = resp_exam.examPlan[0];
                const mockPackageAccess = resp_exam.hasMockSubscription;
                const subscriptionStatus = await PartnerFRMSubscriptionCheck.checkFrm(
                  this.props.params.level,
                  exam_data,
                  examPlanData
                );
                const level = this.props.params.level;
                const hasAccess =
                  (level === '1' && mockPackageAccess['frm']) ||
                  (level === '2' && mockPackageAccess['frm_2']) ||
                  mockPackageAccess['frm_1_2'];
                if (subscriptionStatus || hasAccess) {
                  this._runCode('paid');
                } else {
                  this.setState({
                    isLoading: false,
                  });
                  this.toggleAlert();
                }
              } else {
                //console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.setState({
            isLoading: false,
          });
          this.toggleAlert();
        } else {
          // var data_arr = JSON.parse(resp.profileInfo.exam_selected);
          var dataset1 = {
            token: this.state.token,
            idname: this.state.idname,
            examid: data_arr,
          };
          FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset1).then(
            resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var subscriptionStatus = FrmSubscriptionCheck.checkFrm(
                  this.props.params.level,
                  exam_data,
                );
                if (subscriptionStatus) {
                  this._runCode('paid');
                } else {
                  this.setState({
                    isLoading: false,
                  });
                  this.toggleAlert();
                }
              } else {
                //console.log('fail');
              }
            },
          );
        }
      }
    });
  };

  _runCode = subscriptionstatus => {
    if (subscriptionstatus === 'paid') {
      this.context.router.push({
        pathname: `/frm/introduction/${this.props.params.id}/1/${this.props.params.timer}/${
          this.props.params.level
        }`,
      });
    }
  };

  //On Page Load,init this method
  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      mock_id: this.props.params.id ? parseInt(this.props.params.id, 10) : '',
      level: this.props.params.level ? parseInt(this.props.params.level, 10) : '',
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getAllUsersStats', data).then(resp => {
      if (resp.success) {
        FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getFRMMockQuestions', data).then(
          resp => {
            if (resp && resp.question) {
              this.setState({
                questionsLength: resp.question.length,
              });
            }
          },
        );
        this.setState({
          ValidToken: true,
          mockList: resp.data,
          isLoading: false,
          // userStatsData: resp.data,
        });
      } else {
        this.setState({ ValidToken: false, isLoading: false });
      }
      return resp;
    });

    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getMockNamebyId', data).then(async res => {
      this.setState({
        mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
      });
    });
  }

  goPremium = () => {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  };

  startExam = () => {
    this.setState({
      showInstructionModal: true,
      // mockData: mock,
    });
  };

  backToMock = () => {
    this.context.router.push({
      pathname: '/frm/cbt',
    });
  };

  deleteTest = id => {
    const { deletepopup } = this.state;
    if (!deletepopup) {
      this.setState({
        deleteId: id,
        deletepopup: true,
      });
    } else {
      this.setState({
        deleteId: '',
        deletepopup: false,
      });
    }
  };

  view = item => {
    this.context.router.push({
      pathname: `/frm/cbtquestionsfinish/${this.props.params.id}/1/${this.props.params.timer}/${
        this.props.params.level
      }/${item.id}/0`,
    });
  };

  deleteToggleDone = () => {
    const { deleteId } = this.state;
    const deleteData = {
      token: this.state.token,
      idname: this.state.idname,
      id: deleteId,
    };
    FD.callAPI(App_data.backend_api + '/frmCBTMockExams/deleteMock', deleteData).then(async res => {
      this.setState({
        deleteId: '',
        mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
        deletepopup: false,
      });

      var data = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id, 10) : '',
        level: this.props.params.level ? parseInt(this.props.params.level, 10) : '',
      };
      FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getAllUsersStats', data).then(resp => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            mockList: resp.data,
            isLoading: false,
            // userStatsData: resp.data,
          });
        } else {
          this.setState({ ValidToken: false, isLoading: false });
        }
        return resp;
      });
      FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getMockNamebyId', data).then(
        async res => {
          this.setState({
            mockName: res.mockdata && res.mockdata.mock_exam ? res.mockdata.mock_exam : '',
          });
        },
      );
    });
  };

  resumeTest = item => {
    if (item.questions) {
      let questionsData = JSON.parse(item.lastAnswered);
      //console.log('item', questionsData);
      if (questionsData) {
        this.context.router.push({
          pathname: `/frm/cbtquestions/${this.props.params.id}/${questionsData.questionId}/${
            item.user_time_value
          }/${this.props.params.level}/${item.id}/${questionsData.offset}/true/true`,
        });
      }
    } else {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        mock_id: this.props.params.id ? parseInt(this.props.params.id, 10) : null,
        test_id: item.id,
        level: item.level,
      };
      FD.callAPI(App_data.backend_api + '/frmCBTMockExams/getFRMMockQuestions', data).then(resp => {
        if (resp.success) {
          this.context.router.push({
            pathname: `/frm/cbtquestions/${this.props.params.id}/${
              resp.question && resp.question.length ? resp.question[0].id : 1
            }/${item.user_time_value}/${this.props.params.level}/${item.id}/0/true/true`,
          });
        }
      });
    }
  };

  render() {
    const {
      mockList,
      isLoading,
      showInstructionModal,
      mockName,
      deletepopup,
      questionsLength,
    } = this.state;
    return (
      <div>
        <div className='animated fadeIn'>
          <div className='margin_bottom_20 ques-title-wrapper rem-left-pad'>
            <h1 className='section_head'>{mockName}</h1>
            <div className='two-btn-wrapper'>
              <button
                className='btn btn-primary pointer_class mid-btn'
                onClick={() => this.startExam()}
              >
                {language.LC().START}
              </button>
              <button
                className='btn btn-primary pointer_class mid-btn'
                onClick={() => this.backToMock()}
              >
                {language.LC().CHANGE_MOCK}
              </button>
            </div>
          </div>
          <Modal isOpen={deletepopup} toggle={this.deleteTest} className={'modal-primary'}>
            <ModalHeader>
              {language.LC().ALERT}
              <Button className='close' color='secondary' onClick={this.deleteTest}>
                ×
              </Button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{language.LC().ARE_YOU_SURE_TO_DELETE_THIS}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.deleteToggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
          </Modal>

          <div className='row' />
          <div className='row'>
            <div className='col-md-12'>
              <div className='card height_70vh'>
                <div className='table_responsive_wrapper'>
                  <div className='table-responsive'>
                    <table className='table_white_bg table table-remove-space'>
                      <thead>
                        <tr className='border_top_0'>
                          <th width='9%'>#</th>
                          <th>{language.LC().TOTAL_SCORE}</th>
                          <th>{language.LC().DATE}</th>
                          <th>{language.LC().TEST_COMPLETED_IN}</th>
                          <th>{language.LC().STATUS}</th>
                          <th className='text-center'>{language.LC().ACTION}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading ? (
                          <tr>
                            <Loader />
                          </tr>
                        ) : mockList.length ? (
                          mockList.map((item, index) => {
                            let time = 0;
                            if (item.isNegative === 'true') {
                              time = SecondsToHHMMSS(
                                parseInt(this.props.params.timer, 10) - item.user_time_value,
                              );
                            } else {
                              time = SecondsToHHMMSS(
                                parseInt(this.props.params.timer, 10) + item.user_time_value,
                              );
                            }
                            return (
                              <tr key={index}>
                                <td>{item.id}.</td>
                                <td className='score-qnt'>
                                  {item.score && questionsLength
                                    ? `${Math.ceil((item.score / questionsLength) * 100)}%`
                                    : '0%'}
                                </td>
                                <td>{item.createdAt ? moment(item.createdAt).format('ll') : ''}</td>
                                <td className='clr-green'>{time}</td>
                                <td className='text-capitalize mock-status'>
                                  {item.status === 'pending' ? (
                                    <div className='mock-status not-attempted'>
                                      {/* {item.status} */}
                                      {language.LC().Incomplete}
                                    </div>
                                  ) : (
                                    <div className='mock-status'>{item.status}</div>
                                  )}
                                </td>
                                <td className='text-center'>
                                  {item.status === 'completed' ? (
                                    <span
                                      className='up tooltip-hover-questions'
                                      style={{ padding: '0 6px 4px' }}
                                    >
                                      <div className='tootip_box'> {language.LC().VIEW} </div>
                                      <i
                                        onClick={() => this.view(item)}
                                        className='fa fa-eye mark-action-btn-dashboard'
                                        style={{ color: '#1f8ceb' }}
                                      >
                                        {' '}
                                      </i>
                                    </span>
                                  ) : null}
                                  {item.status === 'pending' ? (
                                    <span
                                      className='up tooltip-hover-questions'
                                      style={{ padding: '0 6px 4px' }}
                                    >
                                      <div className='tootip_box'> {language.LC().RESUME}</div>
                                      <i
                                        className='fa fa-play-circle-o mark-action-btn-dashboard'
                                        aria-hidden='true'
                                        style={{ color: '#000' }}
                                        onClick={() => {
                                          this.resumeTest(item);
                                        }}
                                      />
                                    </span>
                                  ) : null}
                                  <span
                                    className='up tooltip-hover-questions'
                                    style={{ padding: '0 6px 4px' }}
                                  >
                                    <div className='tootip_box'> {language.LC().DELETE} </div>
                                    <i
                                      onClick={() => {
                                        this.deleteTest(item.id);
                                      }}
                                      className='fa fa-trash mark-action-btn-dashboard'
                                      style={{ color: '#f51a00' }}
                                    >
                                      {' '}
                                    </i>
                                  </span>
                                </td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan={'5'} className={'no-mocks'}>
                              <div className='no-qus-found no-mock-exam'>
                                <img
                                  width='82px'
                                  src={App_data.frontend_url + '/img/questions/icon_nomock.png'}
                                  alt=''
                                />
                                <h3 className='mt-1'>{language.LC().NO_MOCK_EXAM_FOUND}</h3>
                              </div>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalComponent
          goPremium={this.goPremium.bind(this)}
          toggleAlert={this.toggleAlert.bind(this)}
          alert_status={this.state.alert_status}
          MessageContent={this.state.MessageContent}
        />
        <CBTMockExamsInsructions
          showInstructionModal={showInstructionModal}
          getQuestions={() => this.getQuestions()}
          handleClose={() => this.setState({ showInstructionModal: false })}
        />
      </div>
    );
  }
}

export default CBTMockExams;



// WEBPACK FOOTER //
// ./src/views/CBT/FRMCBT/ViewAttemptedMocks/index.js